interface DialogDescriptor
{
	body: HTMLElement[];
	head?: HTMLElement[];
	foot?: HTMLElement[];
	id?: string;
	fade?: boolean;
	closeBtn?: boolean;
	selfRemove?: boolean;
}

class Dialog
{

	protected element: HTMLElement;
	protected header?: JQuery;
	protected body: JQuery;
	protected footer?: HTMLElement;

	constructor(
		descriptor: DialogDescriptor,
		bodyscroll: boolean = false,
	)
	{
		this.element = document.createElement( 'div' );
		const doc = $( document.createElement( 'div' ) );
		const content = $( document.createElement( 'div' ) );
		this.body = $( document.createElement( 'div' ) );

		if ( descriptor.id )
		{
			$( this.element ).attr( 'id', descriptor.id );
		}

		$( this.element ).attr( 'tabindex', '-1' );
		$( this.element ).attr( 'role', 'dialog' );
		$( this.element ).addClass( 'modal' );

		if ( descriptor.selfRemove )
		{
			$( this.element ).on(
				'hidden.bs.modal',
				(function( modal: JQuery ): any
				{
					return function()
					{
						modal.remove();
					};
				})( $( this.element ) ),
			);
		}

		if ( descriptor.fade )
		{
			$( this.element ).addClass( 'fade' );
		}

		doc.attr( 'role', 'document' );
		doc.addClass( 'modal-dialog' );

		content.addClass( 'modal-content' );

		$( this.body ).addClass( 'modal-body' );

	 	// Close-Icon
		if ( descriptor.closeBtn )
		{
			const btn_close = $( document.createElement( 'button' ) );

			btn_close.attr( 'type', 'button' );
			btn_close.addClass( 'close' );
			btn_close.attr( 'data-dismiss', 'modal' );
			btn_close.attr( 'aria-label', 'Close' );
			btn_close.html( '&times;' );

			if ( this.header == null )
			{
				this.header = $( document.createElement( 'div' ) );

				$( this.header ).addClass( 'modal-header' );

				content.append( this.header );

				this.header.append( btn_close );
			}
		}

		if ( descriptor.head != null && descriptor.head != undefined )
		{
			if ( this.header == null )
			{
				this.header = $( document.createElement( 'div' ) );

				$( this.header ).addClass( 'modal-header' );

				content.append( this.header );
			}

			for ( const head of descriptor.head )
			{
				$( this.header ).append( head );
			}

		}

		for ( const i in descriptor.body )
		{
			this.body.append( descriptor.body[ i ] );
		}

		if ( bodyscroll )
		{
			let height = $( window ).height();

			if ( !height )
			{
				height = 750;
			}

			height *= 0.6666667;

			this.body.attr(
				'style',
				"overflow-y: scroll !important;\
				 max-height: " + height + "px;",
			);
		}

		content.append( this.body );

		if ( descriptor.foot != null && descriptor.foot != undefined )
		{
			this.footer = document.createElement( 'div' );

			$( this.footer ).addClass( 'modal-footer' );

			for ( const i in descriptor.foot )
			{
				$( this.footer ).append( descriptor.foot[ i ] );
			}

			content.append( this.footer );
		}

		doc.append( content );

		$( this.element ).append( doc );
	}

	public getElement() : HTMLElement
	{
		return this.element;
	}

}
